/* Class-granted Expertise counts (2024 / SRD 5.2.1). CommonJS so Node and the client share the same authority,
 * like spellPreparation.js. Species, background and feat Expertise are counted from their own skill records.
 */
function countClassExpertise(occupation = []) {
  if (!Array.isArray(occupation)) return 0;

  return occupation.reduce((total, entry) => {
    const className = entry?.Occupation || entry?.Name;
    const name = typeof className === 'string' ? className.toLowerCase() : '';
    const level = Number(entry?.Level || entry?.level || 0);

    if (name === 'rogue') {
      return total + (level >= 6 ? 4 : level >= 1 ? 2 : 0);
    }
    // 2024 Bard Expertise: two skills at level 2 and two more at level 9.
    if (name === 'bard') {
      return total + (level >= 9 ? 4 : level >= 2 ? 2 : 0);
    }
    // 2024 Ranger: Expertise in one skill at level 2 (Deft Explorer) and two more at level 9.
    if (name === 'ranger') {
      return total + (level >= 9 ? 3 : level >= 2 ? 1 : 0);
    }
    // 2024 Wizard Scholar: Expertise in one of SCHOLAR_SKILLS at level 2.
    if (name === 'wizard') {
      return total + (level >= 2 ? 1 : 0);
    }
    return total;
  }, 0);
}

const SCHOLAR_SKILLS = Object.freeze(['arcana', 'history', 'investigation', 'medicine', 'nature', 'religion']);

/**
 * Jack of All Trades (Bard 2): half the Proficiency Bonus, rounded down, on a skill check without proficiency in the skill.
 * Tool checks, plain ability checks and Initiative use no skill, so their callers don't ask for it.
 */
function jackOfAllTradesBonus(character, proficiencyBonus, proficient) {
  if (proficient || !Array.isArray(character?.occupation)) return 0;
  const bard = character.occupation.some((entry) => String(entry?.Occupation || entry?.Name).toLowerCase() === 'bard' && Number(entry?.Level || entry?.level || 0) >= 2);
  return bard ? Math.floor((Number(proficiencyBonus) || 0) / 2) : 0;
}

module.exports = { countClassExpertise, SCHOLAR_SKILLS, jackOfAllTradesBonus };
